import React, { FC } from 'react';
import { Control, UseFormSetValue, useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useFormat } from '../../../../hooks/index';
import { FormSchema } from '../stakeholder-actions.validation';
import DayCombobox from './day-combobox';
import MonthCombobox from './month-combobox';
import YearCombobox from './year-combobox';

export type BirthdayDateSelectProps = {
  control: Control<FormSchema>;
  isNeedDefaultValue?: boolean;
  setValue: UseFormSetValue<FormSchema>;
};

const BirthdayDateSelect: FC<BirthdayDateSelectProps> = ({
  setValue,
  control,
  isNeedDefaultValue = false,
}) => {
  const currentYear = new Date().getFullYear();
  const { format } = useFormat();
  const { stepOne } = useWatch<FormSchema>({
    control,
  });
  const birthdayDate = stepOne?.human?.birthdayDate;

  const selectedDay = birthdayDate?.day;
  const selectedMonth = birthdayDate?.month;
  const selectedYear = birthdayDate?.year;

  return (
    <div className="flex w-full flex-col gap-3">
      <span className="text-xs font-medium text-gray-500">
        <AppFormattedMessage id="BIRTHDAY_OPTIONAL" />
      </span>
      <div className="flex w-full gap-4">
        <DayCombobox
          defaultValue={isNeedDefaultValue && selectedDay ? selectedDay : undefined}
          onSelect={(day) => {
            setValue('stepOne.human.birthdayDate.day', day, {
              shouldValidate: true,
            });
          }}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
        />
        <MonthCombobox
          defaultValue={
            isNeedDefaultValue && typeof selectedMonth === 'number'
              ? {
                  index: selectedMonth,
                  month: format(new Date(currentYear, selectedMonth, 1), 'MMMM'),
                }
              : undefined
          }
          onSelect={(month) =>
            setValue('stepOne.human.birthdayDate.month', month.index, {
              shouldValidate: true,
            })
          }
        />
        <YearCombobox
          defaultValue={isNeedDefaultValue && selectedYear ? selectedYear : undefined}
          maxYear={currentYear}
          minYear={1900}
          onSelect={(year) =>
            setValue('stepOne.human.birthdayDate.year', year, {
              shouldValidate: true,
            })
          }
        />
      </div>
    </div>
  );
};

BirthdayDateSelect.displayName = 'BirthdaySelect';

export default BirthdayDateSelect;
